import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../../lib/queryKeys';
import { fetchConstituencies } from '../../lib/api';

export function useConstituencies() {
  return useQuery({
    queryKey: queryKeys.constituencies(),
    queryFn: fetchConstituencies,
  });
}
